import PropTypes from 'prop-types';
import { compose, fromRenderProps, branch, renderNothing } from 'recompose';

import FeatureToggleContext from 'components/feature-toggle/context';

const hideIfNotEnabled = (notEnabled) => branch(notEnabled, renderNothing);

const enhance = compose(
  fromRenderProps(FeatureToggleContext.Consumer, (features) => ({ features })),
  hideIfNotEnabled(({ feature, features }) => !(features || {})[feature])
);

const FeatureToggleConsumer = ({ children }) => children;

FeatureToggleConsumer.propTypes = {
  render: PropTypes.func.isRequired,
};

export default enhance(FeatureToggleConsumer);
